<template>
<section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
            <el-form-item>
                <el-input v-model="filters.poolname" placeholder="请输入流量池名称" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-select v-model="filters.userid" placeholder="请选择服务商" style="width: 100%;" filterable clearable>
                    <el-option v-for="item in options_servicerman" :label="item.servicerName" :value="item.userid+''" :key="item.userid+''">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="filters.packagecode" placeholder="请选择套餐" style="width: 100%;" filterable clearable>
                    <el-option v-for="item in options_cardtype" :label="item.name" :value="item.code" :key="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" v-on:click="getFlowPoolList">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleAdd">新增流量池</el-button>
            </el-form-item>
        </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="flowPools" highlight-current-row v-loading="listLoading" style="width: 100%;">
        <el-table-column prop="poolname" label="流量池名称" min-width="150">
        </el-table-column>
        <el-table-column prop="servicername" label="服务商" min-width="150">
        </el-table-column>
        <el-table-column prop="packagename" label="套餐名称" min-width="150">
        </el-table-column>
        <el-table-column prop="gprsSize" label="套餐流量(MB)" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="addtime" label="添加时间" min-width="180" sortable>
            <template scope="scope">
                <el-icon name="time"></el-icon>
                <span>{{ scope.row.addtime }}</span>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
            <template scope="scope">
                <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button size="small" @click="deleteFlowPool(scope.$index, scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑流量池" :visible.sync="editFormVisible" :close-on-click-modal="false" @close="editFormHandleClose">
        <el-form :model="editForm" label-width="150px" :rules="editFormRules" ref="editForm">
            <el-form-item label="流量池名称：" prop="poolname">
                <el-input v-model="editForm.poolname" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="一级服务商：" prop="userid">
                <el-select v-model="editForm.userid" placeholder="请选择" style="width: 100%;" filterable clearable>
                    <el-option v-for="item in options_servicerman" :label="item.servicerName" :value="item.userid+''" :key="item.userid+''">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐名称：" prop="packagecode">
                <el-select v-model="editForm.packagecode" placeholder="请选择" style="width: 100%;" filterable clearable>
                    <el-option v-for="item in options_cardtype" :label="item.name" :value="item.code" :key="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.native="editFormHandleClose">取消</el-button>
            <el-button type="primary" @click.native="editSubmit" :loading="addLoading">保存</el-button>
        </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增流量池" :visible.sync="addFormVisible" :close-on-click-modal="false" @close="addFormHandleClose">
        <el-form :model="addForm" label-width="150px" :rules="addFormRules" ref="addForm">
            <el-form-item label="流量池名称：" prop="poolname">
                <el-input v-model="addForm.poolname" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="一级服务商：" prop="userid">
                <el-select v-model="addForm.userid" placeholder="请选择" style="width: 100%;" filterable clearable>
                    <el-option v-for="item in options_servicerman" :label="item.servicerName" :value="item.userid+''" :key="item.userid+''">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐名称：" prop="packagecode">
                <el-select v-model="addForm.packagecode" placeholder="请选择" style="width: 100%;" filterable clearable>
                    <el-option v-for="item in options_cardtype" :label="item.name" :value="item.code" :key="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.native="addFormHandleClose">取消</el-button>
            <el-button type="primary" @click.native="addSubmit" :loading="addLoading">保存</el-button>
        </div>
    </el-dialog>
</section>
</template>

<script>
import util from '../../common/js/util'
import constant from '../../common/js/constant'
//import NProgress from 'nprogress'
import {
    getFlowPoolListPage,
    editFlowPool,
    addFlowPool,
    delFlowPool,
    getUserOneList,
    getAllPackList,
    getCardCount
} from '../../api/api';

export default {
    data() {
        return {
            dialogVisible: false,
            //查询过滤条件
            filters: {
                //流量池名称
                poolname: '',
                //请选择服务商
                userid: '',
                //请选择套餐
                packagecode: ''
            },
            flowPools: [], //分页数据
            total: 0, //列表总条数
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            listLoading: false,
            options_servicerman:[],//服务商下拉框
            options_cardtype: [],//套餐下拉框
            editFormVisible: false, //编辑界面是否显示
            editLoading: false,
            editFormRules: {
                poolname: [{
                    required: true,
                    message: '请输入流量池名称',
                    trigger: 'blur'
                }],
                userid: [{
                    required: true,
                    message: '请选择服务商',
                    trigger: 'change'
                }],
                packagecode: [{
                    required: true,
                    message: '请选择套餐',
                    trigger: 'change'
                }]
            },
            //编辑界面数据
            editForm: {
                poolname: '',
                userid: '',
                packagecode: ''
            },

            addFormVisible: false, //新增界面是否显示
            addLoading: false,
            addFormRules: {
                poolname: [{
                    required: true,
                    message: '请输入流量池名称',
                    trigger: 'blur'
                }],
                userid: [{
                    required: true,
                    message: '请选择服务商',
                    trigger: 'change'
                }],
                packagecode: [{
                    required: true,
                    message: '请选择套餐',
                    trigger: 'change'
                }]
            },
            //新增界面数据
            addForm: {
                poolname: '',
                userid: '',
                packagecode: ''
            }

        }
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val;
            this.getFlowPoolList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getFlowPoolList();
        },
        //获取流量池列表
        getFlowPoolList() {
            let para = {
                pageSize: this.pageSize,
                pageNum: this.currentPage
            };

            para = Object.assign(para, this.filters);

            this.listLoading = true;
            //NProgress.start();
            getFlowPoolListPage(para).then((res) => {
                this.total = res.data.total;
                this.flowPools = res.data.list;
                this.listLoading = false;
                //NProgress.done();
            });
        },
        //删除按钮
		deleteFlowPool:function(index, row){
            let para = {userid:row.userid,flowpoolid:row.id};
            getCardCount(para).then((res) => {
                if(res.data > 0){
                    this.$message({
                        message: '流量池已关联卡，不允许删除',
                        type: 'success'
                    });
                }else{
                    this.$confirm('确认删除吗？', '提示', {}).then(() => {
                        var param = {
                            id: row.id,
                        };
                        delFlowPool(param).then((res) => {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.getFlowPoolList();
                        });
                    });
                }
            });
		},
        //显示编辑界面
        handleEdit: function (index, row) {
            let para = {userid:row.userid,flowpoolid:row.id};
            getCardCount(para).then((res) => {
                if(res.data > 0){
                    this.$message({
                        message: '流量池已关联卡，不允许编辑',
                        type: 'success'
                    });
                }else{
                    this.editFormVisible = true;
                    this.editForm = Object.assign({}, row);
                }
            });
        },
        //显示新增界面
        handleAdd: function () {
            this.addFormVisible = true;
        },
        //关闭新增配置界面触发
        addFormHandleClose: function (done) {
            this.$refs['addForm'].resetFields();
            //done();
            this.addFormVisible = false;
        },
        //关闭编辑配置界面触发
        editFormHandleClose: function (done) {
            this.$refs['editForm'].resetFields();
            //done();
            this.editFormVisible = false;
        },
        //编辑
        editSubmit: function () {
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        this.editLoading = true;
                        //NProgress.start();
                        let para = Object.assign({}, this.editForm);
                        editFlowPool(para).then((res) => {
                            this.editLoading = false;
                            //NProgress.done();
                            let {
                                msg,
                                code
                            } = res;
                            console.log(res);
                            if (code !== 0) {
                                this.$message({
                                    message: msg,
                                    type: 'error'
                                });
                            } else {
                                this.$message({
                                    message: '提交成功',
                                    type: 'success'
                                });
                                this.$refs['editForm'].resetFields();
                                this.editFormVisible = false;
                                this.getFlowPoolList();
                            }
                        });
                    });
                }
            });
        },
        //新增
        addSubmit: function () {
            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        this.addLoading = true;
                        //NProgress.start();
                        let para = Object.assign({}, this.addForm);
                        addFlowPool(para).then((res) => {
                            this.addLoading = false;
                            //NProgress.done();

                            let {
                                msg,
                                code
                            } = res;
                            if (code !== 0) {
                                this.$message({
                                    message: msg,
                                    type: 'error'
                                });
                            } else {
                                this.$message({
                                    message: '提交成功',
                                    type: 'success'
                                });
                                this.$refs['addForm'].resetFields();
                                this.addFormVisible = false;
                                this.getFlowPoolList();
                            }

                        });
                    });
                }
            });
        }

    },
    mounted() {
        let para = {};
        getAllPackList(para).then((res) => {
            this.editLoading = false;
            var arr = new Array();
            if(res.data != null && res.data.length >0){
                for(var i=0;i<res.data.length;i++){
                    if(res.data[i].type != '叠加卡'){
                        arr.push(res.data[i]);
                    }
                }
            }
            this.options_cardtype = arr;
        });
        getUserOneList(para).then((res) => {
            this.options_servicerman = res.data;
        });

        this.getFlowPoolList();
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// flow_pool.vue?0c7b213d